const Insightful = {
  warning: {
    main: '#F4AE3D',
    light: '#FCF0BA',
    dark: '#5E0000',
    '10': '#5D0000',
    '20': '#751C00',
    '30': '#C85500',
    '40': '#F19035',
    '50': '#F4AE3D',
    '60': '#F7C444',
    '70': '#FBE38E',
    '80': '#FCF0BA',
    '90': '#FFF6CD',
    '95': '#FEFAE8',
    '100': '#FEFCF4',
  },
};

export default Insightful;
